import { SvgIcon, SvgIconProps } from '@material-ui/core';

export function LeaderBoardIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon {...props}>
      <path d="M4.5 18H1C0.45 18 0 17.55 0 17V7C0 6.45 0.45 6 1 6H4.5C5.05 6 5.5 6.45 5.5 7V17C5.5 17.55 5.05 18 4.5 18ZM11.75 0H8.25C7.7 0 7.25 0.45 7.25 1V17C7.25 17.55 7.7 18 8.25 18H11.75C12.3 18 12.75 17.55 12.75 17V1C12.75 0.45 12.3 0 11.75 0ZM19 8H15.5C14.95 8 14.5 8.45 14.5 9V17C14.5 17.55 14.95 18 15.5 18H19C19.55 18 20 17.55 20 17V9C20 8.45 19.55 8 19 8Z" />
    </SvgIcon>
  );
}
